import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { IconButton } from '@shipt/design-system-buttons'
import { Stack } from '@shipt/design-system-layouts'
import { Body } from '@shipt/design-system-typography'
import { InfoCircleIcon } from '@shipt/design-system-icons'
import { useQueryNycOrdinanceFee } from '@/features/shop/services/Fees/queries'
import { DynamicConfirmationModal } from '@/features/shared/components/Modal/ConfirmationModal/DynamicConfirmationModal'

export const NycOrdinanceFeeBanner = () => {
  const { openDialog } = useHandleDialog()
  const { data: nycOrdinanceFeeData } = useQueryNycOrdinanceFee()
  const firstFeeResult = nycOrdinanceFeeData ? nycOrdinanceFeeData.result : null
  const shouldShowNycOrdinanceFeeBanner = firstFeeResult?.nyc_delivery_fee_applicable

  if (!shouldShowNycOrdinanceFeeBanner) return null

  const handleInfoIconClick = () => {
    openDialog(DynamicConfirmationModal, {
      modalTitle: 'NYC Ordinances Response Fee',
      modalMessage: firstFeeResult.description,
      acceptButtonLabel: 'Okay',
      showReject: false,
      size: 'md',
    })
  }

  return (
    <Stack align="center" justify="center" spacing="xxs" margin={['xs', 0]}>
      <Body size="sm" lineHeight="compact" variant="secondary">
        {firstFeeResult.label}
      </Body>
      <IconButton
        icon={InfoCircleIcon}
        size="sm"
        variant="ghost"
        onClick={handleInfoIconClick}
        aria-label="More information about the NYC Ordinances Response Fee"
      />
    </Stack>
  )
}
